export default function ExportButtons({ onExcel, onPdf }) {
    return (
        <div className="toolbar-row">
            <button onClick={onExcel}>Exportar Excel</button>
            <button onClick={onPdf}>Exportar PDF</button>
        </div>
    );
}